import { createFileRoute } from "@tanstack/react-router";
import { BillingDashboard } from "@/features/billing/BillingDashboard";
import { usePageTitle } from "@/hooks/usePageTitle";
import { z } from "zod";

const billingSearchSchema = z.object({
  year: z.number().optional(),
  month: z.number().optional(),
  simPartnerId: z.number().optional(),
}).optional();

export const Route = createFileRoute("/_dashboard/billing/")({
  component: BillingPage,
  validateSearch: billingSearchSchema,
});

function BillingPage() {
  usePageTitle("請求データ管理");

  return <BillingDashboard />;
}